import { render, staticRenderFns } from "./DiagnosticEvent.vue?vue&type=template&id=12a8bdc0&scoped=true"
import script from "./DiagnosticEvent.vue?vue&type=script&lang=js"
export * from "./DiagnosticEvent.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticEvent.vue?vue&type=style&index=0&id=12a8bdc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8bdc0",
  null
  
)

export default component.exports